import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { useAssignRoom } from './use-assign-room';

import type { QueryKey } from '@tanstack/react-query';

export const useUpdateAssigneeAssignTool = (queryKey: QueryKey) => {
  const queryClient = useQueryClient();

  const callBack = useCallback(() => {
    queryClient.invalidateQueries(queryKey);
  }, []);

  useAssignRoom(callBack);
};
